import { useQuery, keepPreviousData } from '@tanstack/react-query';
import qs from 'qs';
import type { AgentApiJobChangeProcessesIndex } from '@/types/serializers';

/**
 * 「未対応の選考リマインド」用のフック。
 * - schedule_statuses=[adjust_scheduling, result_waiting] を渡し、
 *   日程調整中 + 結果待ちの選考だけを取得する（未対応 = この2状態）。
 * - last_acted_at 昇順（最終アクションが古い順 = 経過日数が大きい順）で取得し、
 *   優先度が高いものから表示する。
 * - `organizationUserId` を渡すと担当者で絞り込む。
 * - スクロール表示のため 1 ページにまとめて取得する（`perPage` で件数指定、既定 30）。
 *   `keepPreviousData` で前データを保持しつつ裏でフェッチする。
 */
export default function useFetchSelectionReminders(
  page: number,
  organizationUserId?: string,
  perPage = 30
) {
  const query = qs.stringify(
    {
      schedule_statuses: ['adjust_scheduling', 'result_waiting'],
      order: 'last_acted_at',
      page,
      per_page: perPage,
      ...(organizationUserId ? { organization_user_id: organizationUserId } : {}),
    },
    { arrayFormat: 'brackets' }
  );

  return useQuery<AgentApiJobChangeProcessesIndex>({
    queryKey: ['/agent/api/job_change_processes', 'selection-reminders', query],
    queryFn: async () => {
      const response = await fetch(`/agent/api/job_change_processes.json?${query}`);
      if (!response.ok) {
        throw new Error('未対応の選考リマインドの取得に失敗しました');
      }
      return response.json() as Promise<AgentApiJobChangeProcessesIndex>;
    },
    placeholderData: keepPreviousData,
  });
}
